// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../node_modules/slick-carousel/slick/ajax-loader.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "#slick" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 80px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h2,
h3 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h4,
p,
a,
button,
label,
input {
  font-size: 24px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  margin: 16px 0px;
  padding: 8px 16px;
  border: 4px solid rgb(69, 102, 124);
  border-radius: 500px;
  background-color: white;
  color: rgb(31, 33, 26);
  transition: background-color 0.3s ease;
}
button:hover {
  cursor: pointer;
  background-color: rgb(69, 102, 124);
  color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}

.mobile-only {
  display: none;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 24px;
  z-index: 2;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 2px;
  background-color: rgb(31, 33, 26);
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
}

@media screen and (max-width: 980px) {
  h1 {
    font-size: 40px;
  }
  h2,
  h3 {
    font-size: 32px;
  }
  h4,
  p,
  a,
  button,
  label,
  input {
    font-size: 20px;
  }
  .mobile-only {
    display: flex;
  }
}
/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Slider */
.slick-loading .slick-list {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
}

/* Icons */
@font-face {
  font-family: "slick";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 20px;
  width: 20px;
  line-height: 0px;
  font-size: 0px;
  cursor: pointer;
  background: transparent;
  color: transparent;
  top: 50%;
  transform: translate(0, -50%);
  padding: 0;
  border: none;
  outline: none;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  background: transparent;
  color: transparent;
}
.slick-prev:hover:before, .slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
  opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  color: white;
  opacity: 0.75;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  left: -25px;
}
[dir=rtl] .slick-prev {
  left: auto;
  right: -25px;
}
.slick-prev:before {
  content: "←";
}
[dir=rtl] .slick-prev:before {
  content: "→";
}

.slick-next {
  right: -25px;
}
[dir=rtl] .slick-next {
  left: -25px;
  right: auto;
}
.slick-next:before {
  content: "→";
}
[dir=rtl] .slick-next:before {
  content: "←";
}

/* Dots */
.slick-dotted.slick-slider {
  margin-bottom: 30px;
}

.slick-dots {
  position: absolute;
  bottom: -25px;
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  height: 20px;
  width: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 20px;
  width: 20px;
  outline: none;
  line-height: 0px;
  font-size: 0px;
  color: transparent;
  padding: 5px;
  cursor: pointer;
}
.slick-dots li button:hover, .slick-dots li button:focus {
  outline: none;
}
.slick-dots li button:hover:before, .slick-dots li button:focus:before {
  opacity: 1;
}
.slick-dots li button:before {
  position: absolute;
  top: 0;
  left: 0;
  content: "•";
  width: 20px;
  height: 20px;
  font-family: "slick";
  font-size: 6px;
  line-height: 20px;
  text-align: center;
  color: black;
  opacity: 0.25;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-dots li.slick-active button:before {
  color: black;
  opacity: 0.75;
}

.healthcare-container {
  width: 100vw;
  padding: 24px;
  background-color: white;
}
.healthcare-container .carousel-container {
  width: 100%;
  margin: 0 auto;
}
.healthcare-container .slick-slider {
  overflow: hidden;
}
.healthcare-container .slick-slide div .slide {
  display: flex;
  align-items: center;
  justify-content: center;
}
.healthcare-container .slick-slide div .slide img {
  max-width: 20vw;
  height: auto;
}

@keyframes moveRight {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/healthcare.scss","webpack://./src/styles/main.scss","webpack://./node_modules/slick-carousel/slick/slick.scss","webpack://./node_modules/slick-carousel/slick/slick-theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACShB;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;ADPF;;ACUA;EACE,kBAAA;EACA,4CAAA;ADPF;ACUA;EACE,wBAAA;EACA,4CAAA;ADRF;ACWA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBA7Bc;ADoBhB;;ACYA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAtCc;AD6BhB;;ACYA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ADTF;;ACYA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAnDO;EAoDP,uBAAA;EACA,sBA3DW;EA4DX,sCAAA;ADTF;ACWE;EACE,eAAA;EACA,mCA/DY;EAgEZ,yBAlEU;EAmEV,sCAAA;ADTJ;;ACaA;EACE,aAAA;ADVF;;ACaA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ADVF;ACYE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ADVJ;ACYI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iCA9FO;ADoFb;ACaI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ADXN;ACcI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ADZN;ACeI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ADbN;ACiBE;EACE,eAAA;ADfJ;;ACmBA;EACE;IACE,eAAA;EDhBF;ECmBA;;IAEE,eAAA;EDjBF;ECoBA;;;;;;IAME,eAAA;EDlBF;ECqBA;IACE,aAAA;EDnBF;AACF;AE/HA,WAAA;AAEA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;AFgIJ;;AE9HA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AFiIJ;AE/HI;EACI,aAAA;AFiIR;AE9HI;EACI,eAAA;EACA,YAAA;AFgIR;;AE7HA;;EAMI,+BAAA;AFgIJ;;AE7HA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AFgIJ;AE9HI;EAEI,WAAA;EACA,cAAA;AF+HR;AE5HI;EACI,WAAA;AF8HR;AE3HI;EACI,kBAAA;AF6HR;;AE1HA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;AFmHJ;AE7HI;EACI,YAAA;AF+HR;AE7HI;EACI,cAAA;AF+HR;AE7HI;EACI,aAAA;AF+HR;AE1HI;EACI,oBAAA;AF4HR;AEzHI;EACI,cAAA;AF2HR;AExHI;EACI,kBAAA;AF0HR;AEvHI;EACI,cAAA;EACA,YAAA;EACA,6BAAA;AFyHR;;AEtHA;EACI,aAAA;AFyHJ;;AGlLA,WAAA;AAGI;EACI,gFAAA;AHmLR;;AG/KA,UAAA;AAEI;EACI,oBAAA;EACA,4CAAA;EACA,mPAAA;EACA,mBAAA;EACA,kBAAA;AHiLR;AG7KA,WAAA;AAEA;;EAEI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EAGA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AH8KJ;AG7KI;;;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AHiLR;AGhLQ;;;EACI,UAjEa;AHqPzB;AGjLI;;EACI,aApEmB;AHwP3B;AGlLI;;EACI,oBAlFY;EAmFZ,eAAA;EACA,cAAA;EACA,YAnFY;EAoFZ,aA7EgB;EA8EhB,mCAAA;EACA,kCAAA;AHqLR;;AGjLA;EACI,WAAA;AHoLJ;AGnLI;EACI,UAAA;EACA,YAAA;AHqLR;AGnLI;EACI,YA9Fe;AHmRvB;AGpLQ;EACI,YA/FW;AHqRvB;;AGjLA;EACI,YAAA;AHoLJ;AGnLI;EACI,WAAA;EACA,WAAA;AHqLR;AGnLI;EACI,YA3Ge;AHgSvB;AGpLQ;EACI,YA9GW;AHoSvB;;AGjLA,SAAA;AAEA;EACI,mBAAA;AHmLJ;;AGhLA;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AHmLJ;AGlLI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AHoLR;AGnLQ;EACI,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AHqLZ;AGpLY;EACI,aAAA;AHsLhB;AGrLgB;EACI,UApJK;AH2UzB;AGpLY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YA9JM;EA+JN,WAAA;EACA,YAAA;EACA,oBAxKI;EAyKJ,cAjKC;EAkKD,iBAAA;EACA,kBAAA;EACA,YAzKE;EA0KF,aAlKW;EAmKX,mCAAA;EACA,kCAAA;AHsLhB;AGnLQ;EACI,YAhLM;EAiLN,aA3KY;AHgWxB;;AA/WA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AAkXF;AAhXE;EACE,WAAA;EACA,cAAA;AAkXJ;AA/WE;EACE,gBAAA;AAiXJ;AA9WE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAgXJ;AA9WI;EACE,eAAA;EACA,YAAA;AAgXN;;AA3WA;EACE;IACE,yBAAA;EA8WF;EA5WA;IACE,2BAAA;EA8WF;AACF","sourcesContent":["@import \"./main.scss\";\n@import \"~slick-carousel/slick/slick.scss\";\n@import \"~slick-carousel/slick/slick-theme.scss\";\n\n.healthcare-container {\n  width: 100vw;\n  padding: 24px;\n  background-color: white;\n\n  .carousel-container {\n    width: 100%; // Adjust the width of the carousel container as needed\n    margin: 0 auto;\n  }\n\n  .slick-slider {\n    overflow: hidden;\n  }\n\n  .slick-slide div .slide {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      max-width: 20vw; // Adjust the max width of your logos\n      height: auto;\n    }\n  }\n}\n\n@keyframes moveRight {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n","$light-color: rgb(241, 243, 255);\n$dark-color: rgb(31, 33, 26);\n$primary-color: rgb(69, 102, 124);\n$secondary-color: rgb(43, 45, 36);\n\n$mobile-width: 980px;\n\n$radius: 500px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 80px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh2,\nh3 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 24px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  margin: 16px 0px;\n  padding: 8px 16px;\n  border: 4px solid $primary-color;\n  border-radius: $radius;\n  background-color: white;\n  color: $dark-color;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n    transition: background-color 0.3s ease;\n  }\n}\n\n.mobile-only {\n  display: none;\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 24px;\n  z-index: 2;\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 2px;\n      background-color: $dark-color;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  h1 {\n    font-size: 40px;\n  }\n\n  h2,\n  h3 {\n    font-size: 32px;\n  }\n\n  h4,\n  p,\n  a,\n  button,\n  label,\n  input {\n    font-size: 20px;\n  }\n\n  .mobile-only {\n    display: flex;\n  }\n}\n","/* Slider */\n\n.slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n        outline: none;\n    }\n\n    &.dragging {\n        cursor: pointer;\n        cursor: hand;\n    }\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n        content: \"\";\n        display: table;\n    }\n\n    &:after {\n        clear: both;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n}\n.slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir=\"rtl\"] & {\n        float: right;\n    }\n    img {\n        display: block;\n    }\n    &.slick-loading img {\n        display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n        pointer-events: none;\n    }\n\n    .slick-initialized & {\n        display: block;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n\n    .slick-vertical & {\n        display: block;\n        height: auto;\n        border: 1px solid transparent;\n    }\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n","@charset \"UTF-8\";\n\n// Default Variables\n\n// Slick icon entity codes outputs the following\n// \"\\2190\" outputs ascii character \"←\"\n// \"\\2192\" outputs ascii character \"→\"\n// \"\\2022\" outputs ascii character \"•\"\n\n$slick-font-path: \"./fonts/\" !default;\n$slick-font-family: \"slick\" !default;\n$slick-loader-path: \"./\" !default;\n$slick-arrow-color: white !default;\n$slick-dot-color: black !default;\n$slick-dot-color-active: $slick-dot-color !default;\n$slick-prev-character: \"\\2190\" !default;\n$slick-next-character: \"\\2192\" !default;\n$slick-dot-character: \"\\2022\" !default;\n$slick-dot-size: 6px !default;\n$slick-opacity-default: 0.75 !default;\n$slick-opacity-on-hover: 1 !default;\n$slick-opacity-not-active: 0.25 !default;\n\n@function slick-image-url($url) {\n    @if function-exists(image-url) {\n        @return image-url($url);\n    }\n    @else {\n        @return url($slick-loader-path + $url);\n    }\n}\n\n@function slick-font-url($url) {\n    @if function-exists(font-url) {\n        @return font-url($url);\n    }\n    @else {\n        @return url($slick-font-path + $url);\n    }\n}\n\n/* Slider */\n\n.slick-list {\n    .slick-loading & {\n        background: #fff slick-image-url(\"ajax-loader.gif\") center center no-repeat;\n    }\n}\n\n/* Icons */\n@if $slick-font-family == \"slick\" {\n    @font-face {\n        font-family: \"slick\";\n        src: slick-font-url(\"slick.eot\");\n        src: slick-font-url(\"slick.eot?#iefix\") format(\"embedded-opentype\"), slick-font-url(\"slick.woff\") format(\"woff\"), slick-font-url(\"slick.ttf\") format(\"truetype\"), slick-font-url(\"slick.svg#slick\") format(\"svg\");\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n/* Arrows */\n\n.slick-prev,\n.slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0px;\n    font-size: 0px;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n    &:hover, &:focus {\n        outline: none;\n        background: transparent;\n        color: transparent;\n        &:before {\n            opacity: $slick-opacity-on-hover;\n        }\n    }\n    &.slick-disabled:before {\n        opacity: $slick-opacity-not-active;\n    }\n    &:before {\n        font-family: $slick-font-family;\n        font-size: 20px;\n        line-height: 1;\n        color: $slick-arrow-color;\n        opacity: $slick-opacity-default;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n    }\n}\n\n.slick-prev {\n    left: -25px;\n    [dir=\"rtl\"] & {\n        left: auto;\n        right: -25px;\n    }\n    &:before {\n        content: $slick-prev-character;\n        [dir=\"rtl\"] & {\n            content: $slick-next-character;\n        }\n    }\n}\n\n.slick-next {\n    right: -25px;\n    [dir=\"rtl\"] & {\n        left: -25px;\n        right: auto;\n    }\n    &:before {\n        content: $slick-next-character;\n        [dir=\"rtl\"] & {\n            content: $slick-prev-character;\n        }\n    }\n}\n\n/* Dots */\n\n.slick-dotted.slick-slider {\n    margin-bottom: 30px;\n}\n\n.slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    li {\n        position: relative;\n        display: inline-block;\n        height: 20px;\n        width: 20px;\n        margin: 0 5px;\n        padding: 0;\n        cursor: pointer;\n        button {\n            border: 0;\n            background: transparent;\n            display: block;\n            height: 20px;\n            width: 20px;\n            outline: none;\n            line-height: 0px;\n            font-size: 0px;\n            color: transparent;\n            padding: 5px;\n            cursor: pointer;\n            &:hover, &:focus {\n                outline: none;\n                &:before {\n                    opacity: $slick-opacity-on-hover;\n                }\n            }\n            &:before {\n                position: absolute;\n                top: 0;\n                left: 0;\n                content: $slick-dot-character;\n                width: 20px;\n                height: 20px;\n                font-family: $slick-font-family;\n                font-size: $slick-dot-size;\n                line-height: 20px;\n                text-align: center;\n                color: $slick-dot-color;\n                opacity: $slick-opacity-not-active;\n                -webkit-font-smoothing: antialiased;\n                -moz-osx-font-smoothing: grayscale;\n            }\n        }\n        &.slick-active button:before {\n            color: $slick-dot-color-active;\n            opacity: $slick-opacity-default;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
